module.exports = __webpack_public_path__ + "static/media/4-apr14sep14.e4fdf9a8.pdf";